import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { List, CrudForm, ListApi, FormApi } from "elentari";
import { treinoObjetivoApi as api } from "../../services/Api";

export function TreinoObjetivoList(props) {
  const listOptions = {
    defaultOrder: "nome",
    fields: {
      id: {
        label: "Id",
      },
      nome: {
        label: "Nome",
      },
    },
  };

  return (
    <ListApi api={api}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          deleteItem={handleDelete}
          labelNew="Novo"
          onClickEdit={(item) =>
            props.history.push(`/treino-objetivos/${item.id}`)
          }
          onClickNew={() => props.history.push("/treino-objetivos/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function TreinoObjetivoForm(props) {
  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
  });

  return (
    <FormApi api={api} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container spacing={16}>
            <Grid item sm>
              <Field
                fullWidth
                autoFocus
                component={TextField}
                label="Nome"
                name="nome"
              />
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
